export default __webpack_public_path__ + "static/media/DarthVader.7145d163.png";